import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatRowKeyboardSelectionModule } from '../../../../core/directive/mat-row-keyboard-selection.module';
import { ResizeColumnModule } from '../../../../core/directive/resize-column.module';
import { MaterialListItemComponent } from './material-list-item.component';

@NgModule({
  declarations: [MaterialListItemComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    MatRowKeyboardSelectionModule,
    ResizeColumnModule,
  ],
  exports: [MaterialListItemComponent],
  providers: [],
})
export class MaterialListItemModule {}
